import store from '@/store'

function navigateToLogin(router, routeTo) {
  router.navigate(
    {
      name: 'Login',
      query: { originalUrl: routeTo.url },
    },
    {
      animate: false,
      history: false,
    }
  )
}

const loginRequired = {
  async beforeEnter(routeTo, routeFrom, resolve, reject) {
    await store.dispatch('auth/getCurrentUser')
    const isLoggedIn = store.getters['auth/isLoggedIn']
    if (isLoggedIn) {
      resolve()
    } else {
      reject()
      navigateToLogin(this, routeTo)
    }
  },
}

export function requireAuth(routes) {
  return routes.map((route) => {
    return Object.assign(route, loginRequired)
  })
}
